import { Component } from "react";
import { connect } from "react-redux";
import { hideModal, showModal } from "../../redux/actions/modalActions";
import { Icon } from "../icons/Icon";
import { resetCss } from "../../utils/modal";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { GREATER_BANK, NEWCASTLE_PERMANENT_BANK } from "../../redux/enums";

interface Props extends RouteComponentProps {
  showModal: any;
  hideModal: any;
}

interface State {
  title: string;
  subtitle: string;
  bankType: string | null;
  trialDays: number;
}

class WelcomePremiumModal extends Component<Props, State> {
  state = {
    title: "Welcome to Grocerize Premium.",
    subtitle: "You now have access to all Premium features!",
    bankType: null,
    trialDays: 30,
  };

  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    const bankType = query.get("bank_type");
    const trialDays = query.get("trial_days")
      ? parseInt(query.get("trial_days") as string)
      : 30;

    this.setState({ bankType, trialDays });
  }

  closeModal = () => {
    resetCss();
    this.props.hideModal();
  };

  getModalContent() {
    const { bankType } = this.state;

    // Default content for regular customers
    let title = "Welcome to Grocerize Premium.";
    let subtitle = "You now have access to all Premium features!";
    let bannerImage = "";
    let isBankType = false;
    let courtesyLine = "";

    // Customize content based on bank type
    if (bankType === NEWCASTLE_PERMANENT_BANK) {
      title = "Welcome to Grocerize Premium!";
      courtesyLine = `thanks to ${bankType}.`;
      bannerImage = "/images/newcastle_permanent_welcome_banner.png";
      isBankType = true;
    } else if (bankType === GREATER_BANK) {
      title = "Welcome to Grocerize Premium!";
      courtesyLine = `thanks to ${bankType}.`;
      bannerImage = "/images/greater_bank_welcome_banner.png";
      isBankType = true;
    }

    return { title, subtitle, courtesyLine, bannerImage, isBankType };
  }

  render() {
    const { title, subtitle, courtesyLine, bannerImage, isBankType } =
      this.getModalContent();

    return (
      <div
        className={
          isBankType ? "o-modal__container" : "u-br--small o-modal__container"
        }
      >
        <div
          className="o-modal--content-centered u-modal--content-bottom--mobile u-w-all--mobile u-relative"
          style={{
            width: window.innerWidth > 600 ? "500px" : "100%",
            maxHeight: "90vh",
            overflow: "auto",
            borderRadius: isBankType ? "0px" : "8px",
          }}
        >
          <button
            className="u-absolute"
            style={{ top: 18, right: 18 }}
            onClick={() => this.closeModal()}
            aria-label="Close welcome modal"
          >
            <Icon id="clear" stroke="white" size="s" />
          </button>

          <div
            className={`u-background--magenta u-color-white ${
              !isBankType ? "u-br--small" : ""
            } u-text-center u-pv--48 u-ph--24`}
          >
            <div className="u-pb--24">
              <Icon id="grocerize_premium_white" width={180} height={45} />
            </div>

            {isBankType ? (
              <>
                <h1
                  className="u-bold u-mb--8"
                  style={{ fontSize: "25px", lineHeight: "1.2" }}
                >
                  {title}
                </h1>
                <p
                  className="u-mb--8"
                  style={{ fontSize: "24px", lineHeight: "1.2" }}
                >
                  The first 6 months of your
                </p>
                <p
                  className="u-mb--8"
                  style={{ fontSize: "24px", lineHeight: "1.2" }}
                >
                  subscription is FREE,
                </p>
                <p
                  className="u-mb--32"
                  style={{ fontSize: "24px", lineHeight: "1.2" }}
                >
                  {courtesyLine}
                </p>
              </>
            ) : (
              <>
                <h1 className="u-main-font--large u-bold u-mb--16">{title}</h1>
                <p className="u-main-font--medium u-mb--32">{subtitle}</p>
              </>
            )}

            {/* Call to Action button - only show for non-bank modals */}
            {!isBankType && (
              <div className="footer-action">
                <button
                  className="u-background--white u-color-magenta u-pv--12 u-ph--24 u-bold u-br--small"
                  onClick={this.closeModal}
                >
                  Start Exploring
                </button>
              </div>
            )}
          </div>

          {/* Bank Welcome Banner Image */}
          {bannerImage && (
            <div
              style={{
                width: "100%",
                borderRadius: "0 0 8px 8px",
                overflow: "hidden",
              }}
            >
              <img
                src={bannerImage}
                alt="Bank Welcome Banner"
                style={{
                  width: "100%",
                  display: "block",
                }}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect(null, { showModal, hideModal })(
  withRouter(WelcomePremiumModal)
);
